import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isMobileNavbar: false,

  //! main menu state
  activeMenu: null,

  //! nested submenu
  subMenuData: null,
  isSubMenuOpen: false,
};

export const MobileNavbarSlice = createSlice({
  name: "mobileNavBar",
  initialState,
  reducers: {
  

    setActiveMenu: (state, action) => {
      state.activeMenu = action.payload;
      state.subMenuData = null;
      state.isSubMenuOpen = false;
    },

    openSubMenu: (state, action) => {
      console.log(action.payload, "submenudata");

      state.subMenuData = action.payload;
      state.isSubMenuOpen = true;
    },

    closeSubMenu: (state) => {
      state.isSubMenuOpen = false;
      state.subMenuData = null;
    },

    toggleMobileNavbar: (state) => {
  state.isMobileNavbar = !state.isMobileNavbar;
},

closeMobileNavbar: (state) => {
  state.isMobileNavbar = false;
},

  },
});

export const { toggleMobileNavbar, closeMobileNavbar, setActiveMenu, openSubMenu, closeSubMenu,  } =
  MobileNavbarSlice.actions;

export default MobileNavbarSlice.reducer;
